import { render, staticRenderFns } from "./BraceletBuilder.vue?vue&type=template&id=4b5e1584&scoped=true&"
import script from "./BraceletBuilder.vue?vue&type=script&lang=js&"
export * from "./BraceletBuilder.vue?vue&type=script&lang=js&"
import style0 from "./BraceletBuilder.vue?vue&type=style&index=0&id=4b5e1584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e1584",
  null
  
)

export default component.exports